module.exports = __webpack_public_path__ + "img/compra_libros.3541c20a.svg";